<template>
  <div
    v-if="!shouldShowBreadcrumbs"
    class="bread-crumb-wrap"
  >
    <UBreadcrumb
      v-if="links.length > 1"
      :links="links"
      divider="/"
    >
      <template #label="{ link, index, isActive }">
        <span
          v-if="link"
          class="isActive ? 'text-gray-900'"
        >
          {{ link.label }}
        </span>
      </template>
    </UBreadcrumb>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { onMounted, computed, watch, ref } from 'vue';
import { useParentAdsStore } from '~/store/parent-ads';
import { useRoute } from 'vue-router';

interface BreadcrumbLink {
  label: string;
  to?: string;
}
const { locale, t } = useI18n();
const route = useRoute();
const parentAdsStore = useParentAdsStore();
const { parentAdsList } = storeToRefs(parentAdsStore);

const links = ref<any>([]);

const handleLinks = () => {
  const temp: BreadcrumbLink[] = [
    {
      label: t('home'),
      to: '/',
    },
  ];

  const adsCategory = route.query.category;
  const adsCategoryName = route.query.categoryName?.toString();
  if (adsCategory && adsCategoryName) {
    temp.push({
      label: adsCategoryName,
      to: `/products?category=${adsCategory}&categoryName=${adsCategoryName}`,
    });
  }

  const adsType = route.query.adsType;
  const adsTypeName = route.query.adsTypeName?.toString();
  if (adsType && adsTypeName) {
    temp.push({
      label: adsTypeName,
      to: `/products?category=${adsCategory}&categoryName=${adsCategoryName}&adsType=${adsType}&adsTypeName=${adsTypeName}`,
    });
  }

  const subchapter = route.query.subchapter;
  const subchapterName = route.query.subchapterName?.toString();
  if (subchapter && subchapterName) {
    temp.push({
      label: subchapterName,
      to: `/products?category=${adsCategory}&categoryName=${adsCategoryName}&adsType=${adsType}&adsTypeName=${adsTypeName}&subchapter=${subchapter}&subchapterName=${subchapterName}`,
    });
  }

  links.value = temp;
};


const shouldShowBreadcrumbs = computed(() => {
  return route.path.includes('create');
});

watch(
  () => route.query,
  (v) => {
    handleLinks();
  }
);

watch(
  () => locale.value,
  (v) => {
    handleLinks();
  }
);

onMounted(() => {
  handleLinks();
});
</script>
<style scoped lang="scss">
.bread-crumb-wrap {
  position: relative;
  margin-bottom: 10px;
}

@media screen and (max-width: 1050px) {
  .bread-crumb-wrap {
    margin-top: 50px;
  }
}
@media screen and (max-width: 650px) {
  // .bread-crumb-wrap {
  //   display: none;
  // }

  .bread-crumb-wrap {
    margin-top: 65px;
  }
}
</style>
